import React from "react";
import { ArrowBackCircle } from "react-ionicons";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import stylesASAP from "./stylesASAP";
import stylesMed from "../MedRep/stylesMed";
import Loading from "../Loading";

export default class Reports2 extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      checked: [],
      catalogs: [],
      catalogsCopy: [],
      allCatalogs: [],
      clients: [],
      clientsCopy: [],
      clientIndex: -1,
      showClients: false,
      disableClient: false,
      selectedClient: 0,
      token: "",
      authenticate: false,
      alertUndefined: false,
      settingArray:[],
      types: [
        {id : 0 , name:"Local Transactions" , setting:"Local_Transactions"},
        {id : 1 , name:"Local Daily Summary" , setting:"Local_Daily_Summary"},
        {id : 2 , name:"Local Collection" , setting:"Local_Collection"},
        {id : 3 , name:"Local Out-Of-Route Visits" , setting:"Local_Out_of_Route_Visits"},
        {id : 4 , name:"Local Routed Visits" , setting:"Local_Routed_Visits"},
        {id : 5 , name:"Item Sales Report " , setting:"Item_Sales"},
        {id : 6 , name:"Competitor Logs" , setting:"Competitor_Logs"},
      ],
    };
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";

    const token = localStorage.getItem("Token");
    const settingArray = JSON.parse(localStorage.getItem("SettingArray")) || [];
    await this.setState({ token: JSON.parse(token) , settingArray:settingArray});
    
     this.filterTypesFromSettingArray();
  }

filterTypesFromSettingArray = () => {
  const settings = Array.isArray(this.state.settingArray) ? this.state.settingArray : [];
  const visibleReportSetting = settings.find(item => item.key === "Visibile_Report_Type");
  const allowedSettings = Array.isArray(visibleReportSetting?.value) ? visibleReportSetting.value : null;
  const competitorEnabled = settings.some(
    item => item.key === "Competitor" && String(item.value).toLowerCase() === "enabled"
  );

  const filteredTypes = !allowedSettings
    ? this.state.types
    : this.state.types.filter(type => {
        if (type.setting === "Competitor_Logs") {
          return competitorEnabled || allowedSettings.includes(type.setting);
        }
        return allowedSettings.includes(type.setting);
      });

  this.setState({ types: filteredTypes });
}

  onItemClick = (item) => {
    localStorage.setItem("ReportId", JSON.stringify(item));
    this.props.history.push("/ReportsAsap");
  };

  render() {

      return (
        <div
          className="container-fluid vh-100 "
          style={stylesASAP.mainContainer}
        >
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className="btn"
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="pt-3">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.push("./LandingPage")}
              color={"#65a0ff"}
              height="50px"
              width="50px"
            />
          </div>
          <p className="pt-3 text-center h3" style={stylesASAP.itemName}>Reports List</p>
          <div className="pt-2">
    <div className="row mt-5">
        {this.state.types.map((item, index) => (
            <div className="col-md-6 pt-3" key={index}>
                <div className="card text-center">
                    <div className="card-body btn catalog rounded-3 shadow" style={stylesASAP.fullwidth}  onClick={() => this.onItemClick(item.id)}>
                        <h5 className="card-title mb-3" style={stylesASAP.itemName2}>{item.name}</h5>
                       
                    </div>
                </div>
            </div>
        ))}
    </div>
</div>

        </div>
      );
    
  }
}
